import XEUtils from 'xe-utils'
import Md5 from './md5'
import store from '../../store/index'
import router from '@/router/index'
import { MessageBox } from 'element-ui'
import http from '@/axios'

// 日期格式化
export function ykDateFormat(fmt, str) {
  if (!str) {
    return ''
  }
  var date = new Date(str)
  if (!date) {
    return ''
  }
  if (date.getFullYear() === 1900) {
    return ''
  } else {
    return XEUtils.toDateString(str, fmt)
  }
}

// table 移除空行
export function removeEmptyForTable(table, defaultArray = []) {
  let tableData = table.getTableData().fullData
  for (let row of tableData) {
    let ifRemove = true
    for (let key in row) {
      if (key !== '_XID' && !defaultArray.includes(key)) {
        if (row[key] !== null) {
          ifRemove = false
          break
        }
      }
    }
    if (ifRemove) {
      table.remove(row)
    }
  }
}

// 移除数组为null,''的属性
export function removeArrayNull(array) {
  for (let obj of array) {
    Object.keys(obj).forEach(item => {
      if (!obj[item]) {
        delete obj[item]
      }
    })
  }
  return array
}
// 移除对象为null,''的属性
export function removeObjectNull(obj, exception = []) {
  let copy = JSON.parse(JSON.stringify(obj))
  Object.keys(copy).forEach(item => {
    if (!copy[item] && !exception.includes(typeof copy[item])) {
      delete copy[item]
    }
  })
  return copy
}

// 打开界面
export function openPush({ url, id, title = '相关菜单', msg, params }) {
  let menuArgs = ''
  let directory = ''
  let vueName = ''
  let ifCanOpen = false
  let path = `/${Md5.md5(url)}`
  let menu = JSON.parse(JSON.stringify(store.state.menulist))

  const dfs = n => {
    if (!n.children) return
    for (let item of n.children) {
      if (!item.children && '/' + item.md5Path === path) {
        // item.children 不存在, 意味着当前节点是叶子节点
        directory = item.directory
        vueName = item.pathDetail
        menuArgs = item.menuArgs
        title = item.name
        return true
      } else if (item.children?.length) {
        // 非叶子节点，继续深度遍历
        let result = dfs(item)
        if (result) {
          return result
        }
      }
    }
    return false
  }

  // menu: [{ children:[], key:'', name:''}, ..]
  for (let n of menu) {
    ifCanOpen = dfs(n)
    if (ifCanOpen) {
      break
    }
  }

  let message = msg === '' ? '是否跳转到对应界面？' : msg

  return new Promise(promiseResolve => {
    MessageBox.confirm(message, '提示', {
      distinguishCancelAndClose: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      new Promise(resolve => {
        if (ifCanOpen === false) {
          MessageBox.confirm(`您没有打开${title}的权限！`, '提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        }
        resolve(ifCanOpen)
      }).then(result => {
        if (result) {
          router.push({
            name: path,
            params: {
              directory: directory,
              vueName: vueName,
              menuArgs: menuArgs,
              id: id,
              ...params
            }
          })
          promiseResolve(true)
        }
      })
    })
  })
}

/**
 * 获取通用附件列表
 * @param {*} vuePath 页面
 * @param {*} id 单据标识
 * @returns 附件列表
 */
export async function getCommonAttachments(vuePath, id) {
  let attachmentList = []
  if (!vuePath || !id) {
    return
  }

  const { data: res } = await http.post('/Base/BAttachment/common', {
    vuePathName: vuePath,
    aKeyValue: id
  })

  if (res.isSuccess) {
    attachmentList = res.data
  } else {
    MessageBox({
      message: res.errorMessage,
      type: 'error',
      title: '提示'
    })
  }
  return attachmentList
}

/**
 * 删除通用附件
 * @param {*} id 附件标识
 * @returns 是否删除成功
 */
export async function removeAttachmentOne(id) {
  const { data: res } = await http.delete(`/Base/BAttachment/common/${id}`)
  return res
}

/**
 * 上传通用附件
 * @param {*} fileList 附件对象列表
 * fileList: [
    {
      "keyValue": 0,
      "fileName": "string",
      "display": "string",
      "fileClass": "string",
      "filePath": "string",
      "type": "string",
      "fileSize": "string",
      "byteSize": "string",
      "memo": "string"
    }
  ]
 * @returns 是否上传成功
 */
export async function uploadAttachments(fileList) {
  const { data: res } = await http.post('/Base/BAttachment/common-bulk-insert', fileList)
  return res.isSuccess
}

// 小写金额转化大写金额
export function AmountLtoU(num) {
  if (isNaN(num)) return ''
  var strPrefix = ''
  if (num < 0) strPrefix = '(负)'
  num = Math.abs(num)
  if (num >= 1000000000000) return '无效数值！'
  var strOutput = ''
  var strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分'
  var strCapDgt = '零壹贰叁肆伍陆柒捌玖'
  num += '00'
  var intPos = num.indexOf('.')
  if (intPos >= 0) {
    num = num.substring(0, intPos) + num.substr(intPos + 1, 2)
  }
  strUnit = strUnit.substr(strUnit.length - num.length)
  for (var i = 0; i < num.length; i++) {
    strOutput += strCapDgt.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1)
  }
  return (
    strPrefix +
    strOutput
      .replace(/零角零分$/, '整')
      .replace(/零[仟佰拾]/g, '零')
      .replace(/零{2,}/g, '零')
      .replace(/零([亿|万])/g, '$1')
      .replace(/零+元/, '元')
      .replace(/亿零{0,3}万/, '亿')
      .replace(/^元/, '零元')
  )
}

// 生成uuid
export function GenreactUUID() {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  // bits 12-15 of the time_hi_and_version field to 0010
  s[14] = '4'
  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  // bits 8-11 of the clock_seq_low to 0
  s[8] = s[13] = s[18] = s[23]
  var uuid = s.join('')
  return uuid
}
